import { EntitySettingBase } from './base';
import { CampaignSetting } from './campaign';
import { AdGroupSetting } from './adgroup';
import { KeywordSetting } from './keyword';
import { AssetGroupSetting } from './assetgroup';

export function getEntitySetting(entity, i18n, selectedRule, accountCurrencyCode, bidBudgetRange) {
  const entitySettingMapping = {
    campaign: CampaignSetting,
    keyword: KeywordSetting,
    adgroup: AdGroupSetting,
    assetgroup: AssetGroupSetting,
  };

  const keyToUse = entity.toLowerCase();
  const ClassToUse = entitySettingMapping[keyToUse] ?
    entitySettingMapping[keyToUse] :
    EntitySettingBase;

  return new ClassToUse({
    entity,
    selectedRule,
    i18n,
    accountCurrencyCode,
    bidBudgetRange,
  });
}
